import { ensureSalesforceOpenCtiReady } from './salesforce-opencti';

export const CORPORATE_APEX = 'hitcomms.HITOpenCti';
let corporate = false;
export const setCorporateApex = (value: boolean) => {
  corporate = value;
};
export const hasCorporateApex = () => corporate;
export const runCrmApex = async (
  apexClass: string,
  methodName: string,
  params: Record<string, string> = {}
): Promise<string> => {
  await ensureSalesforceOpenCtiReady();
  return new Promise((resolve, reject) => {
    sforce.opencti.runApex({
      apexClass,
      methodName,
      methodParams: new URLSearchParams(params).toString(),
      callback: (response) =>
        response.success
          ? resolve(String(response.returnValue.runApex))
          : reject(
              new Error(
                'Salesforce CRM operation failed; check operator access and configuration'
              )
            ),
    });
  });
};

export const createOutgoingCrmRecord = async (
  phone: string,
  flags: {
    leadIntegration: boolean;
    outboundCallJournal: boolean;
    attemptId?: string;
  }
) => {
  if (!flags.leadIntegration && !flags.outboundCallJournal) return;
  let leadId = '';
  if (flags.leadIntegration) {
    try {
      if (corporate) {
        const result = JSON.parse(
          await runCrmApex(CORPORATE_APEX, 'findOrCreateLead', { phone })
        );
        leadId = result.leadId;
      } else {
        // Preserve old package methods, but no longer couple Lead creation to Task creation.
        const result = await runCrmApex('LeadController', 'createLead', {
          firstName: 'Desconhecido',
          lastName: phone,
          phone,
        });
        leadId = /leadId=([^,}]+)/.exec(result)?.[1]?.trim() || '';
      }
    } catch (error) {
      if (!flags.outboundCallJournal) throw error;
      console.warn(
        'Salesforce Lead lookup failed; recording an unlinked call attempt'
      );
    }
  }
  if (flags.outboundCallJournal) {
    if (!corporate)
      throw new Error(
        'Outgoing call journal requires the corporate Salesforce package'
      );
    const attemptId = flags.attemptId || crypto.randomUUID();
    const result = JSON.parse(
      await runCrmApex(CORPORATE_APEX, 'startCall', {
        attemptId,
        phone,
        leadId,
      })
    );
    return { taskId: result.taskId as string, attemptId };
  }
};

export const updateOutgoingCall = async (
  record: { taskId: string; attemptId: string },
  outcome: 'answered' | 'completed' | 'failed',
  durationSeconds?: number
) => {
  await runCrmApex(CORPORATE_APEX, 'updateCall', {
    ...record,
    outcome,
    ...(durationSeconds === undefined
      ? {}
      : { durationSeconds: String(durationSeconds) }),
  });
};
